import { useEffect, useState } from 'react';
import './App.css';
const  ImageGallery = () => {

  const[images,setImages]=useState([]);
  const[isLoading,setIsLoading]=useState(true);
  const[term,setTerm]=useState('happy');
  
useEffect(()=>{
    fetch(`https://pixabay.com/api/?key=21987099-da000e6d0bb9cc8cda8dd7d98&q=${term}
    &image_type=photo&pretty=true`)
    .then(res=>res.json())
    .then(data=>{
      setImages(data.hits);
      setIsLoading(false);
    })
    .catch(err=>console.log(err));
},[images]);
    return ( 
        <div className="container">
        <div className="nav">
        <div className="search">
            <h1 className="logo"><b><i>Pix<sup>search</sup></i></b></h1>
            <input type="text"
            value={term}
            placeholder="Search images here..." 
               onChange={e=>setTerm(e.target.value)}
            />
        </div>
        {/* <div className="links">
            <button>Home</button>
            <button>Photos</button>
            <button>Videos</button>
        </div>
        */}
    </div>
                
     <div className="row">
     {
       images.map((image)=>(
        <div className="col-md-4">
                  <div className="cart">
                  <a href={image.pageURL}>
                    <img  key={image.id} src={image.webformatURL}></img>
                    </a>
                    <div className="info">
                          <span><strong>by {image.user}</strong></span><br/>
                          <span><strong>Likes:</strong></span>{image.likes}
                          <span><strong>Downloads:</strong></span>{image.downloads}
                          
                    </div>
                  </div>
          </div>
       )) }
      
     </div>
</div>
     );
}
 
export default  ImageGallery;